import { render } from "./Dpa.vue?vue&type=template&id=8084cd74"
import script from "./Dpa.vue?vue&type=script&lang=js"
export * from "./Dpa.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__